import { Text } from "@rneui/base";
import { ListItem, Avatar } from "@rneui/themed";
import variables from "src/common/assets/variables";
import { BASE_CONFIG } from "libs/config";
import moment from "moment";
import _ from "lodash";

const Order = ({ item }) => {
  const imgSrc =
    item?.store?.images && `${BASE_CONFIG.base_url}/${item.store.images[0]}`;
  const props = item?.store?.images
    ? { source: { uri: imgSrc } }
    : { title: item?.store?.name.substr(0, 1).toUpperCase() };
  const items = item.items.reduce((acc, cur) => {
    return `${!_.isEmpty(acc) ? `${acc},` : ""} ${cur.name}`;
  }, "");
  return (
    <ListItem bottomDivider>
      <Avatar
        {...props}
        containerStyle={{ backgroundColor: variables.$textLight }}
      />
      <ListItem.Content>
        {item.store.name && (
          <ListItem.Title>{`${item.user.first_name} ${item.user.last_name}`}</ListItem.Title>
        )}
        <ListItem.Subtitle>{items}</ListItem.Subtitle>
      </ListItem.Content>
      <Text>{moment.unix(item.delivery_date).format("MM/DD/YYYY HH:MM")}</Text>
    </ListItem>
  );
};
export default Order;
